<div class="link-button-container d-flex jc-center ai-center fd-row">
  <button class="link-button flex-1" [routerLink]="['.', tileInstance.routeLink]" mat-flat-button>
    <mat-icon *ngIf="tileInstance.buttonIcon">{{ tileInstance.buttonIcon }}</mat-icon>
    {{ tileInstance.buttonText }}
  </button>
</div>
